<a *ngIf="!isDialog" href="javascript:void(0)" (click)="showModal()" id="pdf-file-{{id}}" class="kuba-document-trigger" [attr.aria-label]="pdfName" [title]="pdfName">
    <i class="pi pi-file-pdf kuba-document-icon kuba-document-icon--red" aria-hidden="true"></i>
</a>

<div class="pdf-modal" *ngIf="showModalWindow" id="pdf-file-{{id}}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="kuba-document-heading">
                    <i class="pi pi-file-pdf kuba-document-icon kuba-document-icon--red" aria-hidden="true"></i>
                    <span class="kuba-document-title" [title]="pdfName">
                        {{pdfName}}
                    </span>
                </h4>
                <button (click)="hideModal()" class="close">
                    <span class="icon ic-md icon-multiply"></span>
                </button>
            </div>
            <div class="modal-body" id="pdf-pop-{{id}}">
                <!-- Loading state while processing SAS tokens -->
                <div *ngIf="isProcessingSas" class="file-preview-wrapper">
                    <div class="file-preview-box" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
                        <div style="text-align: center;">
                            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem; margin-bottom: 1rem;">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p>Processing PDF...</p>
                        </div>
                    </div>
                </div>

                <!-- PDF viewer - show after processing is complete OR if processedPdfSrc is available -->
                <div *ngIf="!isProcessingSas && processedPdfSrc" class="file-preview-wrapper">
                    <div class="file-preview-box">
                        <pdf-viewer [src]="processedPdfSrc" [render-text]="true" style="display: block;position: absolute;left: 0;right: 0;top: 0;bottom: 0;"></pdf-viewer>
                    </div>
                </div>

                <!-- Error state (still shows PDF but with warning) -->
                <div *ngIf="sasProcessingError && !isProcessingSas" class="alert alert-warning" style="margin: 10px;">
                    Note: PDF link processing encountered an issue, but the document can still be viewed.
                </div>
            </div>
        </div>
    </div>
</div>
